module.exports = __webpack_public_path__ + "img/T1C_rc_16.46f95608.png";